import NormalConfirmModal from "./NormalConfirmModal";

export default NormalConfirmModal;
